import { FavouriteCondition, Value } from 'app/types-shared';

export const getConditionForOperator = (conditions: FavouriteCondition[], operator: Value) =>
  conditions &&
  conditions.find(condition =>
    condition.values &&
    condition.values.some(value =>
      operator && value.operator && value.operator.v === operator.v)
  ) || undefined;
